import { convertDateFormat } from "components/helper";
import useKothar from "context/useKothar";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/** Mirrors ClientDropdown field mapping for add-form preselect from drill-down links. */
export const applyClientToModuleForm = (prev, client) => ({
  ...prev,
  clientId: client?.id,
  name: client?.name,
  client: client?.name,
  address: client?.address,
  dob: convertDateFormat(client?.dob),
  gender: client?.gender,
  email: client?.email,
  number: client?.number,
  passportNumber: client?.passportNumber,
  visaExpiry: convertDateFormat(client?.visaExpiry),
  visaStatus: client?.visaStatus,
  passportExpiry: convertDateFormat(client?.passportExpiry),
  dateOfIssue: convertDateFormat(client?.dateOfIssue),
  usiNumber: client?.usiNumber,
  emergencyContact: client?.emergencyContact,
  emergencyContactName: client?.emergencyContactName,
  emergencyEmail: client?.emergencyEmail,
  emergencyRelation: client?.emergencyRelation,
  maritalStatus: client?.maritalStatus,
  reference: client?.reference,
  caseOfficer: client?.caseOfficer,
  referral: client?.reference,
});

export function usePreselectClientFromLocation({ setData, editId = null }) {
  const { state } = useLocation();
  const [{ clientList }] = useKothar();
  const appliedRef = useRef(false);

  useEffect(() => {
    if (editId || appliedRef.current) return;
    const clientId = state?.preselectClientId;
    if (!clientId) return;

    const client =
      state?.preselectClient || clientList?.find((c) => String(c.id) === String(clientId));

    if (!client && !clientList?.length) return;

    appliedRef.current = true;
    if (client) {
      setData((prev) => applyClientToModuleForm(prev, client));
    } else {
      setData((prev) => ({ ...prev, clientId: Number(clientId) || clientId }));
    }
  }, [editId, state?.preselectClientId, state?.preselectClient, clientList, setData]);
}
